import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { DiscoveryTitle } from "../../../constants";
import { DiscoverySlider, DiscoverySliderData } from "../../../data/demo/PropertyDemo1";
import { routes } from "../../../routers/routes";
import { dynamicImage, Image } from "../../../utils";
import CommonHeader from "../common/CommonHeader";

const Discovery = () => {
  return (
    <section className="section-b-space property-discovery-section">
      <Container>
        <CommonHeader title={DiscoveryTitle} headClass="title-style-1 dark-title" />
        <Swiper {...DiscoverySlider} className="discovery-slider">
          {DiscoverySliderData.map((property, index) => (
            <SwiperSlide key={index}>
              <Link to={routes.Property.Grid.Property3Grid} className="discovery-img">
                <Image src={dynamicImage(`property/discovery/${property.image}`)} alt={`${property.location}-img`} className="img-fluid" />
                <div className="discovery-content">
                  <h5>{property.location}</h5>
                  <ul>
                    <li>
                      <span>{property.sale} Sale</span>
                    </li>
                    <li>
                      <span>{property.rent} Rent</span>
                    </li>
                  </ul>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Discovery;
